import { render, staticRenderFns } from "./SubmitCategoryItem.vue?vue&type=template&id=0a4e6ec2&scoped=true"
import script from "./SubmitCategoryItem.vue?vue&type=script&lang=js"
export * from "./SubmitCategoryItem.vue?vue&type=script&lang=js"
import style0 from "./SubmitCategoryItem.vue?vue&type=style&index=0&id=0a4e6ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e6ec2",
  null
  
)

export default component.exports